'use client'
import { createContext } from 'react'

interface ErrorHandlerProps {
  error: unknown
  message: string
  time: Date
}

type ContextType = { errorBody: string; clearError?: () => void; errorHandler?: (props: ErrorHandlerProps) => void }
export const ErrorBannerContext = createContext<ContextType>({
  errorBody: '',
  errorHandler: () => {},
  clearError: () => {},
})
